export function escapeSpecialChars(jsonString) {
    return jsonString.replace(/(\r\n|\n|\r)/gm, "");
}
